const DEFAULT_PUBLIC_ASSET_BASE_URL =
  'https://storage.googleapis.com/dotvoting-app/dotvoting/library/latest/public';

const resolvePublicAssetBaseUrl = () => {
  return DEFAULT_PUBLIC_ASSET_BASE_URL;
};

export const getPublicAssetUrl = (assetPath: string) => {
  if (!assetPath) {
    return assetPath;
  }

  if (/^(https?:)?\/\//i.test(assetPath) || assetPath.startsWith('data:')) {
    return assetPath;
  }

  const normalizedPath = assetPath.replace(/^\/+/, '').replace(/^public\/+/, '');
  const base = resolvePublicAssetBaseUrl();

  if (!base) {
    return `/${normalizedPath}`;
  }

  return `${base}/${normalizedPath}`;
};
